import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    ShipmentRuleAssayCreateRequest,
    ShipmentRuleAssayResponse
} from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule-assay/shipment-rule-assay.dto'
import { GridUtils } from '@/shared/util/grid-utils'

class ManualShipmentRuleAssayService {
    async paginator(filterModel: any, params: any, shipmentRuleId: number): Promise<IResponseAgGrid<ShipmentRuleAssayResponse>> {
        const _filterModel = {
            ...filterModel,
            'manualShipmentRule.id': GridUtils.getNumberFilterModel('equals', shipmentRuleId)
        }
        const response = await axios.put<IResponseAgGrid<ShipmentRuleAssayResponse>>(`/configuration/manualShipmentRuleAssays/`, _filterModel, { params })
        return response.data
    }
    async createShipmentRuleAssay(request: ShipmentRuleAssayCreateRequest): Promise<ShipmentRuleAssayResponse> {
        const response = await axios.post<ShipmentRuleAssayResponse>(`/configuration/manualShipmentRuleAssays/`, request)
        return response.data
    }
    async deleteShipmentRuleAssayBatch(shipmentRuleAssayIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/manualShipmentRuleAssays/batch`, { data: shipmentRuleAssayIds })
        return response.data
    }
}
export const manualShipmentRuleAssayService = new ManualShipmentRuleAssayService()
